import { inject, injectable } from 'inversify';
import ApiRepo from '../api.repo';
import { ApiPage } from '@/core/models/page.model';
import { DeleteResellerDiscountPolicy, EndResellerDiscountPolicy, ReplaceResellerDiscountPolicy, ResellerDiscountPolicyModel, SaveResellerDiscountPolicy, UpdateActiveResellerDiscountPolicy, VoidResellerDiscountPolicy } from '@/core/models/reseller-discount-policy.model';

@injectable()
export class ResellerDiscountPolicyRepo {
    @inject(ApiRepo) private apiRepo!: ApiRepo;
    private readonly basePath = '/api/ResellerDiscountPolicy';

    page(waterUserId: string, pageIndex = 1, pageSize = 20) {
        return this.apiRepo.get<ApiPage<ResellerDiscountPolicyModel>>(`${this.basePath}/page`, { waterUserId, pageIndex, pageSize }, true, true);
    }
    detail(id: string) {
        return this.apiRepo.get<ResellerDiscountPolicyModel>(`${this.basePath}/detail`, { id }, true, true);
    }
    addDraft(input: SaveResellerDiscountPolicy) {
        return this.apiRepo.post<ResellerDiscountPolicyModel>(`${this.basePath}/add-draft`, input, undefined, true, true);
    }
    updateDraft(input: SaveResellerDiscountPolicy) {
        return this.apiRepo.post<ResellerDiscountPolicyModel>(`${this.basePath}/update-draft`, input, undefined, true, true);
    }
    updateActive(input: UpdateActiveResellerDiscountPolicy) {
        return this.apiRepo.post<ResellerDiscountPolicyModel>(`${this.basePath}/update-active`, input, undefined, true, true);
    }
    activate(id: string) {
        return this.apiRepo.post<unknown>(`${this.basePath}/activate`, { id }, undefined, true, true);
    }
    replace(input: ReplaceResellerDiscountPolicy) {
        return this.apiRepo.post<unknown>(`${this.basePath}/replace`, input, undefined, true, true);
    }
    end(input: EndResellerDiscountPolicy) {
        return this.apiRepo.post<unknown>(`${this.basePath}/end`, input, undefined, true, true);
    }
    delete(input: DeleteResellerDiscountPolicy) {
        return this.apiRepo.post<unknown>(`${this.basePath}/delete`, input, undefined, true, true);
    }
    void(input: VoidResellerDiscountPolicy) {
        return this.apiRepo.post<unknown>(`${this.basePath}/void`, input, undefined, true, true);
    }
}
